export enum LoginTypeEnum {
  EMAIL = 'email',
  SSO = 'sso',
}
